import { addItemToCollection } from "directus/src/operations";

export async function createCostMaster({ item }) {
  try {
    const data = await addItemToCollection("cost_master", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
